module.exports = __webpack_public_path__ + "img/vote-badge.eea90811.png";